import React from 'react'
import "./color.css"

function OrangeLL() {
    var x = localStorage.getItem("percentage llp")

    return (
        <div className = "orange__backgroundll">
            {x == "NaN" ? "null": x} %
        </div>
    )
}

export default OrangeLL
